(() => {
  const banner = document.querySelector('[data-hce-cookie-banner]');
  if (!banner || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  const primary = banner.querySelector('[data-hce-cookie-primary-actions]');
  const preferencesPanel = banner.querySelector('[data-hce-cookie-preferences]');
  const status = banner.querySelector('[data-hce-cookie-status]');
  const manage = banner.querySelector('[data-hce-cookie-manage]');
  const back = banner.querySelector('[data-hce-cookie-back]');
  const all = banner.querySelector('[data-hce-cookie-all]');
  const essential = banner.querySelector('[data-hce-cookie-essential]');
  const save = banner.querySelector('[data-hce-cookie-save]');
  const choices = Array.from(banner.querySelectorAll('[data-hce-cookie-choice]'));
  let privacy = null;
  let lastFocus = null;

  const setStatus = (message) => { if (status) status.textContent = message; };
  const show = (manageMode = false) => {
    lastFocus = document.activeElement;
    document.body.classList.add('hce-cookie-open');
    banner.hidden = false;
    if (manageMode) openPreferences();
  };
  const hide = () => {
    banner.hidden = true;
    document.body.classList.remove('hce-cookie-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  const visitorConsent = () => {
    try { return privacy?.currentVisitorConsent?.() || {}; }
    catch (e) { return {}; }
  };

  const syncChoices = () => {
    const current = visitorConsent();
    choices.forEach((input) => {
      const key = input.dataset.hceCookieChoice;
      input.checked = current[key] === 'yes';
    });
  };

  const openPreferences = () => {
    syncChoices();
    primary.hidden = true;
    preferencesPanel.hidden = false;
    const first = preferencesPanel.querySelector('input, button');
    if (first) first.focus();
  };
  const closePreferences = () => {
    preferencesPanel.hidden = true;
    primary.hidden = false;
    if (manage) manage.focus();
  };

  const submit = (values, message) => {
    if (!privacy || typeof privacy.setTrackingConsent !== 'function') return;
    privacy.setTrackingConsent(values, () => {
      setStatus(message);
      hide();
    });
  };

  all?.addEventListener('click', () => submit(
    { analytics: true, marketing: true, preferences: true },
    'All optional cookies enabled.'
  ));
  essential?.addEventListener('click', () => submit(
    { analytics: false, marketing: false, preferences: false },
    'Only essential cookies are enabled.'
  ));
  manage?.addEventListener('click', openPreferences);
  back?.addEventListener('click', closePreferences);
  save?.addEventListener('click', () => {
    const values = { analytics: false, marketing: false, preferences: false };
    choices.forEach((input) => { values[input.dataset.hceCookieChoice] = input.checked; });
    submit(values, 'Cookie choices saved.');
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-hce-cookie-settings], a[href$="#cookie-settings"]');
    if (!trigger) return;
    event.preventDefault();
    show(true);
  });

  if (window.location.hash === '#cookie-settings') {
    window.setTimeout(() => show(true), 0);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !banner.hidden && !preferencesPanel.hidden) closePreferences();
  });

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error) {
        console.warn('[HCE privacy] Customer Privacy API could not be loaded.', error);
        return;
      }
      privacy = window.Shopify.customerPrivacy;
      const current = visitorConsent();
      const undecided = ['analytics', 'marketing', 'preferences'].every((key) => !current[key]);
      let shouldShow = false;
      try { shouldShow = privacy.shouldShowBanner(); } catch (e) {}
      if (shouldShow || undecided) show(false);
    }
  );
})();